import { Link } from "react-router-dom";

/* Site footer — clean WHITE background, premium and minimal.
   Dark charcoal headings, muted gray-green links, real routes only. */

const FOOTER_COLUMNS = [
  {
    group: "Learn",
    links: [
      { label: "Practice", href: "/practice-setup", testId: "footer-link-practice" },
      { label: "Watch & Learn", href: "/learn/videos", testId: "footer-link-watch-learn" },
      { label: "PYQs", href: "/pyq", testId: "footer-link-pyqs" },
      { label: "Ask Abhyas AI", href: "/abhyas-ai", testId: "footer-link-ask-ai" },
    ],
  },
  {
    group: "Prepare",
    links: [
      { label: "Study Planner", href: "/dashboard", testId: "footer-link-study-planner" },
      { label: "Smart Practice", href: "/practice-setup", testId: "footer-link-smart-practice" },
      { label: "Exam Mode", href: "/practice-setup", testId: "footer-link-exam-mode" },
      { label: "Reattempt", href: "/dashboard", testId: "footer-link-reattempt" },
    ],
  },
  {
    group: "Company",
    links: [
      { label: "About", href: "/#why", testId: "footer-link-about", anchor: true },
      { label: "Contact", href: "/contact", testId: "footer-link-contact" },
      { label: "Pricing", href: "/#pricing", testId: "footer-link-pricing", anchor: true },
    ],
  },
  {
    group: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy-policy", testId: "footer-link-privacy" },
      { label: "Terms of Service", href: "/terms-of-service", testId: "footer-link-terms" },
      { label: "Refund & Cancellation", href: "/refund-cancellation", testId: "footer-link-refund" },
    ],
  },
];

const SiteFooter = () => (
  <footer
    data-testid="site-footer-container"
    className="border-t border-[#E2E8F0] bg-white text-[#17201A]"
  >
    <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 lg:px-12">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Link to="/" data-testid="footer-logo-home-link" className="inline-flex">
            <img src="/logo.png" alt="Abhyas" className="h-9 w-auto" />
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#647067]">
            AI-powered learning and practice platform for CBSE &amp; ICSE
            students.
          </p>
          <p className="mt-3 text-sm font-bold text-[#16A34A]">
            Practice Smarter. Score Higher.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-4 lg:col-span-8">
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.group}>
              <p className="mb-4 text-[11px] font-extrabold uppercase tracking-[0.16em] text-[#17201A]">
                {col.group}
              </p>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.testId}>
                    {link.anchor ? (
                      <a
                        href={link.href}
                        data-testid={link.testId}
                        className="text-sm font-semibold text-[#647067] transition-colors duration-200 hover:text-[#16A34A]"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        data-testid={link.testId}
                        className="text-sm font-semibold text-[#647067] transition-colors duration-200 hover:text-[#16A34A]"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-[#E2E8F0] pt-6 sm:flex-row">
        <p className="text-xs text-[#647067]">
          © 2026 Abhyas. All rights reserved.
        </p>
        <p className="text-xs font-semibold text-[#647067]">
          Made for CBSE &amp; ICSE students, Classes 9–12.
        </p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
